module.exports = __webpack_public_path__ + "img/header-engagementRingsDiamonds@2x.2b60811.jpg";